import { Select } from "antd";
const { Option } = Select;

export default function SelectLabelBool({
  label,
  onChange,
  placeholder,
  value,
  name,
  error,
}) {
  const handleChange = (val) => {
    onChange({ target: { name, value: val } });
  };

  return (
    <div>
      <div className={`inputLabel ${error && "error"} `}>{label}</div>

      <Select
        value={value}
        placeholder={placeholder}
        onChange={handleChange}
        style={{ width: "100%" }}
      >
        <Option value={true}>Si</Option>
        <Option value={false}>No</Option>
      </Select>
    </div>
  );
}
